import { 
  ElInput,
  ElContainer,
  ElHeader,
  ElFooter,
  ElAside,
  ElMain,
  ElMenu,
  ElSubmenu,
  ElMenuItem,
  ElTabs,
  ElTabPane,
  ElSelect,
  ElOption,
  ElButton,
  ElIcon,
  ElInfiniteScroll,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElButtonGroup,
  ElRadioGroup,
  ElRadioButton
} from 'element-plus'


const components = [
  ElInput,
  ElContainer,
  ElHeader,
  ElFooter,
  ElAside,
  ElMain,
  ElMenu,
  ElSubmenu,
  ElMenuItem,
  ElTabs,
  ElTabPane,
  ElSelect,
  ElOption,
  ElButton,
  ElIcon,
  ElButtonGroup,
  ElRadioGroup,
  ElRadioButton

]
import 'element-plus/lib/theme-chalk/index.css'

const plugins = [
  ElInfiniteScroll,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
]

export {
  components,
  plugins,
}
